import { TextField } from "@mui/material";
import React from "react";

const FormTextField = ({
  label,
  name,
  register,
  errors,
  watch,
  maxLength,
  disabled,
  type,
  multiline,
  rows,
  autoUppercase,
  sx: sxOverride,
}) => {
  const watchValue = watch ? watch(name) : "";
  const currentLength = watchValue ? String(watchValue).length : 0;
  const fieldError = errors?.[name];
  const showCounter = !fieldError && !!maxLength;

  const registration = register(name, {
    ...(autoUppercase && {
      setValueAs: (v) => (v ? String(v).toUpperCase() : v),
    }),
  });

  return (
    <TextField
      fullWidth
      variant="outlined"
      label={label}
      disabled={disabled}
      type={type}
      multiline={multiline}
      rows={rows}
      error={!!fieldError}
      helperText={
        fieldError?.message ||
        (maxLength ? `${currentLength}/${maxLength}` : "")
      }
      FormHelperTextProps={{
        sx: {
          textAlign: showCounter ? "right" : "left",
          fontSize: "11px",
          mx: 0,
        },
      }}
      inputProps={{ maxLength }}
      sx={
        sxOverride || {
          "& input": { height: "22px", padding: "5px 10px", fontSize: "12px" },
        }
      }
      {...registration}
    />
  );
};

export default FormTextField;
